import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function CalendarLegend({ slotStatuses, extraLabels }) {
  const { t } = useTranslation();
  return (
    <div className="col mb-4">
      <div className="row">
        {slotStatuses.map((statusNumber) => (
          <div key={statusNumber} className="col-auto col-sm-4 col-md-3">
            <div className="fc-legend-box">
              <span className={`fc-legend-dot slot-status-${statusNumber}`} />
              <span className="fc-legend-text">{t(`pages.events.slots.status${statusNumber}`)}</span>
            </div>
          </div>
        ))}
        {extraLabels && extraLabels.map((item) => (
          <div key={item.className} className="col-auto col-sm-4 col-md-3">
            <div className="fc-legend-box">
              <span className={`fc-legend-dot ${item.className}`} />
              <span className="fc-legend-text">{item.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

CalendarLegend.propTypes = {
  slotStatuses: PropTypes.arrayOf(PropTypes.number).isRequired,
  extraLabels: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
};

CalendarLegend.defaultProps = {
  extraLabels: [],
};

export default CalendarLegend;
